module.exports = __webpack_public_path__ + "public/images/thumbs-up-rocket-complete-success.00009dff5dd058080c54224b48627140.png";